import { CalculatorUrlKeys, selectPrimaryCalculatorIsPaymentMethodCash, calculatorInitialState, selectPrimaryCalculatorDownPaymentAmount, selectPrimaryCalculatorTradeInValueAmount, selectPrimaryCalculatorTradeInOwingAmount, } from '../../../core/reducers/financialCalculators';
import { selectCurrentVehicleModelYear, selectCurrentVehicleModelKey } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
const useCalculatorParams = (modelKey, modelYear, paymentData) => {
    const currentVehicleModelKey = useAppSelector(selectCurrentVehicleModelKey);
    const currentVehicleModelYear = useAppSelector(selectCurrentVehicleModelYear);
    const isCashPayment = useAppSelector(selectPrimaryCalculatorIsPaymentMethodCash);
    const isCurrentVehicle = modelKey === currentVehicleModelKey && modelYear === currentVehicleModelYear;
    const initialTradeInValueAmount = calculatorInitialState.tradeInValueAmount;
    const initialTradeInOwingAmount = calculatorInitialState.tradeInOwingAmount;
    const primaryCalculatorDownPaymentAmount = useAppSelector(state => selectPrimaryCalculatorDownPaymentAmount(state));
    const primaryCalculatorTradeInValueAmount = useAppSelector(state => selectPrimaryCalculatorTradeInValueAmount(state));
    const primaryCalculatorTradeInOwingAmount = useAppSelector(state => selectPrimaryCalculatorTradeInOwingAmount(state));
    if (!paymentData)
        return;
    const { paymentMethod, paymentFrequency, term } = paymentData;
    // For the currently-selected vehicle
    if (isCurrentVehicle)
        return isCashPayment
            ? {
                [CalculatorUrlKeys.paymentMethod]: paymentMethod,
                [CalculatorUrlKeys.tradeInValue]: String(primaryCalculatorTradeInValueAmount),
            }
            : {
                [CalculatorUrlKeys.paymentFrequency]: paymentFrequency,
                [CalculatorUrlKeys.paymentMethod]: paymentMethod,
                [CalculatorUrlKeys.tradeInValue]: String(primaryCalculatorTradeInValueAmount),
                [CalculatorUrlKeys.tradeInOwing]: String(primaryCalculatorTradeInOwingAmount),
                [CalculatorUrlKeys.downPayment]: String(primaryCalculatorDownPaymentAmount),
                [CalculatorUrlKeys.termAndRate]: String(term),
            };
    // For a vehicles other than the currently-selected vehicle
    return isCashPayment
        ? { [CalculatorUrlKeys.paymentMethod]: paymentMethod }
        : {
            [CalculatorUrlKeys.paymentFrequency]: paymentFrequency,
            [CalculatorUrlKeys.paymentMethod]: paymentMethod,
            [CalculatorUrlKeys.termAndRate]: String(term),
            [CalculatorUrlKeys.tradeInValue]: String(initialTradeInValueAmount),
            [CalculatorUrlKeys.tradeInOwing]: String(initialTradeInOwingAmount),
            [CalculatorUrlKeys.downPayment]: String(primaryCalculatorDownPaymentAmount),
        };
};
export default useCalculatorParams;
